module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Regular.woff?v=f1fc5a0566beb367c9d6120897f7c62c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Regular.woff
// module id = 671
// module chunks = 0